// 1993 Park-Miller LCG
// https://gist.github.com/blixt/f17b47c62508be59987b
function randomLCG (s) {
  return function () {
    s = Math.imul(48271, s) | 0 % 2147483647
    return (s & 2147483647) / 2147483648
  }
}
var rand = randomLCG(Date.now())

// use an uniform distribution of numbers
export function randomIntUniform (min, max) {
  // return Math.floor(Math.random() * (max - min + 1) + min)
  return Math.floor(rand() * (max - min + 1) + min)
}

export function randomUniqueInts (quantity, min, max) {
  const arr = []
  while (arr.length < quantity) {
    var candidate = Math.floor(rand() * (max - min + 1) + min)
    if (arr.indexOf(candidate) === -1) arr.push(candidate)
  }
  return arr
}

// use a power law distribution of numbers
// roughly gives the same number of 1-digit numbers as 2-digit numbers and as ...
export function randomIntPowerLaw (min, max) {
  // return Math.ceil(Math.exp(Math.random() * (Math.log(max) - Math.log(min))) * min)
  return Math.ceil(Math.exp(rand() * (Math.log(max) - Math.log(min))) * min)
}

// random element of an array
export function randomElement (arr) {
  return arr[Math.floor(rand() * arr.length)]
}

// random boolean: true or false
export function randomBoolean (probability = 0.5) {
  return rand() <= probability
}

// random sign: -1 or 1
export function randomSign () {
  return rand() <= 0.5 ? 1 : -1
}

// random factor of a number
export function randomFactorOf (number, lowerbound = null, upperbound = null) {
  var factors = []
  var min = lowerbound || 1
  var max = upperbound || number

  for (var i = min; i <= max; i++) {
    if (number % i === 0) factors.push(i)
  }
  return factors[randomIntUniform(0, factors.length - 1)]
}

// check if a number is prime
export function isPrime (number) {
  for (let i = 2, s = Math.sqrt(number); i <= s; i++) {
    if (number % i === 0) return false
  }
  return (number > 1)
}

// prime factorization
export function primeFactors (number) {
  const factors = []
  let divisor = 2

  while (number >= 2) {
    if (number % divisor === 0) {
      factors.push(divisor)
      number = number / divisor
    } else {
      divisor++
    }
  }
  return factors
}

// GCF (greatest common factor)
export function GCF (a, b) {
  var c
  while (b) {
    c = a % b; a = b; b = c
  }
  return Math.abs(a)
}

// -1 - less than, 0 - equal, 1 - greater than
export function mapInequalitySign (a) {
  return a < 0 ? '<' : (a > 0 ? '>' : '=')
}

// 0 - equal, others - not equal
export function mapEqualitySign (a) {
  return a === 0 ? '=' : '≠'
}

// shuffle the first n items in array
export function shuffle (array, n = null) {
  let maxindex = n ? n - 1 : array.length - 1
  for (let i = maxindex; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let t = array[i]; array[i] = array[j]; array[j] = t
  }
  return array
}

// remove duplicates from array of objects
export function unique (array) {
  return array.filter((o, index, arr) => arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index)
}

// Fill the gap between algebra.js toTex() outputs and mathquill input string format
export function toMathquill (algebrajs) {
  // 1. spaces (algebra.js: x + 3, mathquill: x+3)
  // 2. brackes and exponents (algebra.js: x^{2}, mathquill: x^2)

  return algebrajs.replace(/\s/g, '').replace(/x\^\{(\d)\}/g, 'x^$1')
}



// WEBPACK FOOTER //
// ./src/common/js/mathutil.js